import React from 'react';
import PageShell from './PageShell';
import Seo from '../components/Seo';
import { useI18n } from '../context/I18nContext';
import PricingSection from '../components/PricingSection';
import CommunityCTA from '../components/CommunityCTA';

export function HostingPage() {
  const { tr } = useI18n();
  return (
    <PageShell eyebrow={tr('hosting.eyebrow', 'WEB HOSTING')} title={<><span className="text-white">LiteSpeed </span><span className="gold-text">Hosting</span></>} subtitle={tr('hosting.subtitle', 'Metin2 sunucuları ve web projeleri için optimize edilmiş, ultra hızlı NVMe altyapı.')}>
      <Seo title="Web Hosting" />
      <PricingSection eyebrow={tr('hosting.packages', 'HOSTING PAKETLERİ')} title={tr('hosting.title', 'Hızlı & Güvenli')} subtitle={tr('hosting.desc', 'XenForo, WordPress ve custom PHP için optimize.')} serverType="hosting" showAll />
      <CommunityCTA />
    </PageShell>
  );
}

export function VPSPage() {
  const { tr } = useI18n();
  return (
    <PageShell eyebrow={tr('vps.eyebrow', 'COSMIC VPS')} title={<><span className="text-white">{tr('vps.title1', 'Sanal ')}</span><span className="gold-text">{tr('vps.title2', 'Sunucular')}</span></>} subtitle={tr('vps.subtitle', 'AMD Ryzen 7950X3D destekli, DDoS korumalı yüksek performanslı VPS paketleri.')}>
      <Seo title="Cosmic VPS" />
      <PricingSection eyebrow={tr('vps.packages', 'VPS PAKETLERİ')} title={tr('vps.title', 'Cosmic VPS Serisi')} subtitle={tr('vps.desc', 'Londra lokasyon, 1 Gbps unmetered hat, Cosmic Guard koruma.')} serverType="server" showAll />
      <CommunityCTA />
    </PageShell>
  );
}

export function VDSPage() {
  const { tr } = useI18n();
  return (
    <PageShell eyebrow={tr('vds.eyebrow', 'OYUN SUNUCULARI')} title={<><span className="text-white">Game </span><span className="gold-text">Ryzen VDS</span></>} subtitle={tr('vds.subtitle', 'Yüksek seviyeli izole kaynaklarla oyun sunucuları için kurşungeçirmez güç.')}>
      <Seo title="Game Ryzen VDS" />
      <PricingSection eyebrow={tr('vds.packages', 'VDS PAKETLERİ')} title={tr('vds.title', 'Rakipsiz Performans')} subtitle={tr('vds.desc', 'NVMe SSD, 30 TB bant, Cosmic Guard DDoS.')} serverType="vds" showAll />
      <CommunityCTA />
    </PageShell>
  );
}
